/**
 * HTMLMediaElement.play() rejects when playback is interrupted (e.g. pause(),
 * source change, removal). Those rejections are expected during rapid UI churn
 * and should not surface as unhandled promise rejections.
 */
export function isIgnorableMediaPlaybackError(error: unknown): boolean {
    if (error == null || typeof error !== 'object') {
        return false;
    }
    const { name, message } = error as { name?: string; message?: string };
    if (name === 'AbortError' || name === 'NotAllowedError') {
        return true;
    }
    const msg = typeof message === 'string' ? message : '';
    if (msg.includes('interrupted by a call to pause')) {
        return true;
    }
    if (msg.includes('The play() request was interrupted')) {
        return true;
    }
    return false;
}
